<h4 class="ss-subtitle">Skills</h4>
<div class="container">
  <div *ngFor="let skill of skills" class="skill">
    <div class="skill-content">
      <div class="skill-name" [innerHTML]="skill.skillName"></div>
      <span *ngIf="skill.isFocus" class="focus-skill">Focus Skill</span>
    </div>
  </div>
</div>
